import React from 'react';
import { TrevorComponent, TrevorIcon } from '@trevor/ui-components';
import { FacebookProps } from '@/features/publicDatasets/publicdatasets/PublicDatasetsTopPanel/Social/types';
import openWindow from './openWindow';
import createLinkFor from './createLinkFor';

const Facebook: TrevorComponent<FacebookProps> = ({
  title,
  description,
  picture,
  url,
}) => {
  return (
    <TrevorIcon
      name="facebook"
      size={33}
      onClick={() =>
        openWindow(
          createLinkFor('facebook', {
            u: url,
            title,
            description,
            picture,
          }),
        )
      }
      className="socialButton"
    />
  );
};

export default Facebook;
